export default {
    appHeader: {
        title: 'Solvis ER — Futures Dashboard',
        signOut: 'Sign out',
        loading: 'Loading…',
    },
}
